import { Component, Input, OnInit } from '@angular/core';
import { ViewLeadPopupComponent } from '../view-lead-popup/view-lead-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-crm-and-leads',
  templateUrl: './crm-and-leads.component.html',
  styleUrls: ['./crm-and-leads.component.css']
})
export class CrmAndLeadsComponent implements OnInit {
  @Input() leadStatus: number = 0
  type: any;
  allStaffRecords: any;
  serviceType: string = '';
  selectedServiceType: string = '';

  userTypeName: string = '';
  leads: Array<any> = []
  assignedStaff: string = ''
  remarks = [
    "Quote Sent",
    "Negotiation",
    "Closing Stage",
    "Proposal Shared",
    "Sent Quote (R)"

  ]

  assignedTo = [
    "Arjun Rao",
    "Preethi K",
    "Nihar Ahmed",
    "Sanjana P",
    "Murali Krishna"
  ]
  constructor(private modalService: NgbModal,
    private rsbService: RsbService,
    public lookupModel: RsbLookupModel,
    public rsbLookup: RsbLookupModel,
    private router: Router,
    private toastService: ToastrService
  ) { }

  ngOnInit(): void {
    this.serviceType = this.lookupModel.getSelectedServiceType() ? this.lookupModel.getSelectedServiceType() : 'realEstate';
    this.type = this.lookupModel.getLoggedUser().type ? this.lookupModel.getLoggedUser().type: 'subFranchise'
    this.selectedServiceType = this.serviceType
    this.typeServices('', this.serviceType)
    this.assignedStaff = 'myself'
    this.getStaff()

  }
  getStaff(): void {
    this.rsbService.getStaffData(this.type ==='franchise' ? 'staff' :'subStaff').subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.allStaffRecords = rsp.contents
      }
    })
  }

  typeServices(userType: string, serType: string, id?:string, type?:string): void {
    this.serviceType = serType;
    if (serType === 'realEstate') {
      this.rsbService.getAssignedFranchiseLeadsForFranchise({ "status": 1 }, id, type).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'finTech') {
      this.rsbService.getAssignedFintechLeadsForFranchise({ "status": 1 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else if (serType === 'propService') {
      this.rsbService.getAssignedPropServiceLeadsForFranchise({ "status": 1 }).subscribe((rsp) => {
        if (rsp?.statusCode === 0 && rsp.contents.length) {
          this.leads = rsp.contents;
        } else {
          this.leads = []
        }
      });
    } else {
      alert('Something went wrong');
    }
  }

  selectStaff(event:any) {
    if(event.target.value !== '0') {
    this.typeServices('',this.serviceType, event.target.value, this.type === 'franchise' ?'staff':'subStaff' )
    } else {
      this.typeServices('',this.serviceType, '','')
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'Verified Lead':
        return 'status-verified';
      case 'Qualified Lead':
        return 'status-qualified';
      default:
        return 'status-default';
    }
  }

  getLeadTypeClass(type: string): string {
    switch (type) {
      case 'Online':
      case 'online':
        return 'lead-online';
      case 'Walkin':
        return 'lead-walkin';
      case 'Referral':
        return 'lead-referral';
      default:
        return 'lead-default';
    }
  }

  getCategoryClass(category: string): string {
    switch (category) {
      case 'Sale':
        return 'category-sale';
      case 'Rent':
        return 'category-rent';
      case 'Loans':
      case 'loans':
        return 'cat-loan';
      case 'Housing':
        return 'category-housing';
      case 'creditCard':
        return 'cat-credit-card'
      default:
        return 'category-default';
    }
  }

  getProductClass(product: string): string {
    switch (product) {
      case 'Villa':
        return 'product-villa';
      case 'Apartment':
        return 'product-apartment';
      case 'Land':
        return 'product-land';
      case 'Flat':
        return 'product-flat';
      case 'Plot':
        return 'product-plot';
      case 'Housing':
        return 'product-housing'; // Add this line
      case 'eduloan':
      case 'Edu Loan':
        return 'product-edu-loan'; // Add this line
      case 'Home Loan':
        return 'home-loan';
      case 'LAP':
        return 'laploan'; // Add this line
      case 'Personal/Self':
        return 'personalloan'; // Add this line
      case 'CCTV':
        return 'cctv'; // Add this line
      case 'Interior':
        return 'interior'; // Add this line
      case 'Furniture':
        return 'furniture'; // Add this line
      case 'Packers And Movers':
        return 'packers'; // Add this line

      default:
        return 'product-default';
    }
  }
  selectService(service: string) {
    this.selectedServiceType = service;
    this.serviceType = service;
    this.lookupModel.setSelectedServiceType(this.serviceType);
    this.typeServices(this.lookupModel.getLoggedUser().type, service);
  }

  assignedFunctionStaff(service: string) {
    this.assignedStaff = service
  }


  view(leads: any): void {
    const modalRef = this.modalService.open(ViewLeadPopupComponent);
    modalRef.componentInstance.leadStatus = leads.status
    modalRef.result.then((result) => {
      let payload = {}
      if (result.status == "2") {
        payload = {
          id: this.rsbLookup.getLoggedUser().franchiseId,
          status: result.status,
          leadId: leads.leadId,
          date: result.date,
          description: result.remarks,
          propType: this.serviceType
        }
        if (this.serviceType === 'realEstate') {
          this.rsbService.updateFollowup(payload).subscribe((rsp) => {
            if (rsp.statusCode === 0) {
                this.toastService.success('Lead Successfully Updated To Followup');
              this.followupRedirectedMethod(result)
            }
          })
        } else if (this.serviceType === 'finTech') {
          this.rsbService.updateFollowupForFintech(payload).subscribe((rsp) => {
            if (rsp.statusCode === 0) {
              this.followupRedirectedMethod(result)
            }
          })

        } else {
          this.rsbService.updateFollowupForPropServices(payload).subscribe((rsp) => {
            if (rsp.statusCode === 0) {
              this.followupRedirectedMethod(result)
            }
          })
        }

      } else {
        payload = {
          leadId: leads.leadId,
          status: result.status,
          description: result.remarks
        }

        if (this.serviceType == 'realEstate') {
          this.rsbService.updateLeadStatusForRealEstate(payload).subscribe((rsp) => {
            if (rsp.statusCode === 0) {
              this.toastService.success('Lead Successfully Updated');
              this.redirectMethod(result);
            } else {
              this.toastService.error('Some thing wrong on server side');
            }
          })

        } else if (this.serviceType == 'finTech') {
          this.rsbService.updateLeadStatusForFintech(payload).subscribe((rsp) => {
            if (rsp.statusCode === 0) {
              this.redirectMethod(result);
            } else {
              this.toastService.error('Some thing wrong on server side');
            }
          })

        } else {
          this.rsbService.updateLeadStatusForPropServices(payload).subscribe((rsp) => {
            if (rsp.statusCode === 0) {
              this.redirectMethod(result);
            } else {
              this.toastService.error('Some thing wrong on server side');
            }
          })

        }
      }
    })

  }




  redirectMethod(result: any): void {
    if (result.status == "3") {
      this.router.navigate(['./Leads']);
    } else if (result.status == "4") {
      this.router.navigate(['./Leads']);
    } else {
      this.router.navigate(['./Leads']);
    }
  }
  followupRedirectedMethod(result: any): void {
    const inputDate = new Date(result.date);
    const today = new Date();

    // Normalize both dates to remove time components for accurate comparison
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    if (inputDate > today) {
      this.router.navigate(['./FollowUp']); // Date is in the future
    } else if (inputDate < today) {
      this.router.navigate(['./FollowUp']); // Date is in the past
    } else {
      this.router.navigate(['./FollowUp']); // Date is today
    }

  }


}


